export const DEVELOPER_STATUS = [
  {
    id:'active',
    value:true,
    name:'Active'
  },
  {
    id:'inactive',
    value:false,
    name:'Inactive'
  }
] as const;
